import { ChangeDetectionStrategy, Component, effect, input, model, output, untracked } from '@angular/core'
import { SegmentModifier, SegmentOption } from './segmented-control.models'
import { NgClass } from '@angular/common'
import { DataAttributeDirective } from '../../directives/mcm-data-attribute.directive'
import { TranslatePipe } from '@ngx-translate/core'
import { IonIcon, IonImg, IonLabel, IonSegment, IonSegmentButton } from '@ionic/angular/standalone'

@Component({
  selector: 'app-segmented-control',
  templateUrl: './segmented-control.component.html',
  styleUrls: ['./segmented-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, DataAttributeDirective, TranslatePipe, IonSegment, IonSegmentButton, IonImg, IonIcon, IonLabel]
})
export class SegmentedControlComponent {
  readonly disabled = input(false)
  readonly autoSelect = input(true)
  readonly modifiers = input<SegmentModifier[]>([])
  readonly options = input<SegmentOption[]>([])
  readonly value = model<string>()

  readonly onChange = output<string>()

  constructor() {
    effect(() => {
      const opts = this.options()
      const auto = this.autoSelect()
      const currentValue = untracked(this.value)

      if (opts?.length && auto && !currentValue) {
        const initialId = (opts.find((opt) => opt.selected) || opts[0]).id
        this.value.set(initialId)
      }
    })
  }

  onSegmentValueChanged({ detail: { value } }: any) {
    this.value.set(value)
    this.options().forEach((option) => (option.selected = option.id === value))
    this.onChange.emit(value)
  }
}
